import React from 'react'
import type { InboxParticipant } from 'components/inbox/inboxTypes'
import { handleAvatarError } from 'components/inbox/utils'

interface Props {
  participants: InboxParticipant[]
}

export const ReviewConversationRecipientPills: React.FC<Props> = ({ participants }) => (
  <>
    {participants.map((participant) => (
      <div
        key={`${participant.fullName}-${participant.orgName ?? 'no-org'}`}
        className='message-reviewer-modal__recipient-pill'
      >
        <img
          className='message-reviewer-modal__recipient-avatar'
          src={participant.avatarUrl}
          alt=''
          onError={(event) => handleAvatarError(event.currentTarget)}
        />
        <span className='message-reviewer-modal__recipient-text'>
          <span className='message-reviewer-modal__recipient-name'>
            {participant.fullName}
            {participant.orgName != null && participant.orgName !== '' ? ',' : ''}
          </span>
          {participant.orgName != null && participant.orgName !== '' && (
            <span className='message-reviewer-modal__recipient-org'>{participant.orgName}</span>
          )}
        </span>
      </div>
    ))}
  </>
)
